import { cn } from '@/lib/utils'

/** Marque Oyenga : anneau plein + satellite, déclinable sur fond clair ou sombre. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={cn('size-7 shrink-0', className)}
      fill="none"
    >
      <rect width="32" height="32" rx="8" className="fill-primary" />
      <path
        d="M16 7.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm0 3.6a4.9 4.9 0 1 1 0 9.8 4.9 4.9 0 0 1 0-9.8Z"
        className="fill-primary-foreground"
      />
      <circle cx="23.2" cy="22.6" r="3.1" className="fill-primary-foreground" />
      <circle cx="23.2" cy="22.6" r="1.35" className="fill-primary" />
    </svg>
  )
}

export function BrandWordmark({
  className,
  onSteel = false,
}: {
  className?: string
  onSteel?: boolean
}) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <BrandMark />
      <span className="flex flex-col leading-none">
        <span
          className={cn('text-sm font-semibold tracking-tight', onSteel && 'text-steel-foreground')}
        >
          Oyenga
        </span>
        <span
          className={cn(
            'text-[0.6875rem] font-medium tracking-[0.14em] uppercase',
            onSteel ? 'text-steel-muted' : 'text-muted-foreground',
          )}
        >
          Operations
        </span>
      </span>
    </span>
  )
}
